<script>
const pageOptions = {
    pageWithSidebar: true,
    pageWithMobileSidebar: false,
    pageWithHeaderToggles: true,
    pageWithHeaderNavigation: true,
    pageWithCenteredFooter: false
}

export default pageOptions;
</script>